import * as actioTypes from "store/types";

export const getBanners = (payload) => ({
  type: actioTypes.GET_BANNERS,
  payload,
});

export const getFaqs = (payload) => ({
  type: actioTypes.GET_FAQS,
  payload,
});

export const getTrucks = (payload) => ({
  type: actioTypes.GET_TRUCKS,
  payload,
});

export const getTerms = (payload) => ({
  type: actioTypes.GET_TERMS,
  payload,
});

export const getRefund = (payload) => ({
  type: actioTypes.GET_REFUND,
  payload,
});

export const activeHeader = (payload) => ({
  type: actioTypes.ACTIVE,
  payload,
});

export const showProducts = (payload) => ({
  type: actioTypes.SHOW_PRODUCTS,
  payload,
});

export const addVideo = (payload) => ({
  type: actioTypes.ADD_VIDEO,
  payload,
});
export const addVideos = (payload) => ({
  type: actioTypes.ADD_VIDEOS,
  payload,
});

export const getFeatureImages = (payload) => ({
  type: actioTypes.GET_FEATURE_IMAGES,
  payload,
});

export const getProducts = (payload) => ({
  type: actioTypes.GET_PRODUCTS,
  payload,
});

export const addComparisonData = (payload) => ({
  type: actioTypes.GET_COMPARISON_DATA,
  payload,
});

export const getTeams = (payload) => ({
  type: actioTypes.GET_TEAMS,
  payload,
});

export const getCities = (payload) => ({
  type: actioTypes.GET_CITIES,
  payload,
});

export const getStates = (payload) => ({
  type: actioTypes.GET_STATES,
  payload,
});

export const getLocations = (payload) => ({
  type: actioTypes.GET_LOCATIONS,
  payload,
});

export const getTransactionDetails = (payload) => ({
  type: actioTypes.GET_TRANSACTION_DETAILS,
  payload,
});

export const removeTransactionDetails = (payload) => ({
  type: actioTypes.REMOVE_TRANSACTION_DETAILS,
  payload,
});

export const getDealershipDetails = (payload) => ({
  type: actioTypes.GET_DEALERSHIP_DETAILS,
  payload,
});

export const removeDealershipDetails = (payload) => ({
  type: actioTypes.REMOVE_DEALERSHIP_DETAILS,
  payload,
});

export const saveScreens = (payload) => ({
  type: actioTypes.SAVE_SCREENS,
  payload,
});
